var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.season3,"items-per-page":100}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }